// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// I think it would be good to move the constants here from DynProperty
export var DynPropertyTypes;
(function (DynPropertyTypes) {
    DynPropertyTypes[DynPropertyTypes["INTEGER"] = 0] = "INTEGER";
    DynPropertyTypes[DynPropertyTypes["DOUBLE"] = 1] = "DOUBLE";
    DynPropertyTypes[DynPropertyTypes["COMBOBOX"] = 27] = "COMBOBOX";
    DynPropertyTypes[DynPropertyTypes["COMBOBOX_COMBOITEM_TIF"] = 1001] = "COMBOBOX_COMBOITEM_TIF"; // Combobox with Time-In-Force (TIF)
})(DynPropertyTypes || (DynPropertyTypes = {}));
